import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HOME_BOXES } from '../../core/constants/general.constants';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from '../../core/services/auth.service';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  faArrowUpRightFromSquare = faArrowUpRightFromSquare;
  homeBoxes: any = [];

  constructor(
    private authService: AuthService
  ){}

  ngOnInit(): void {
    this.buildHomeBoxes();
  }

  private buildHomeBoxes() {
    for (let homeBox of HOME_BOXES) {
      let buildedHomeBox: any = { section: '', boxes: [] };
      buildedHomeBox.section = homeBox.section;
      for (let box of homeBox.boxes) {
        if (box.roles && box.roles.length > 0) {
          if (this.authService.hasRole(box.roles)) {
            buildedHomeBox.boxes.push(box);
          }
        } else {
          buildedHomeBox.boxes.push(box);
        }
      }
      if (buildedHomeBox.boxes.length > 0) {
        this.homeBoxes.push(buildedHomeBox);
      }
    }

  }

}
